import {useState} from 'react';

import AddIcon from '@mui/icons-material/Add';
import {Alert} from '@mui/material';
import {LocalizationProvider} from '@mui/x-date-pickers';
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';
import PropTypes from 'prop-types';
import {useFieldArray, useFormContext} from 'react-hook-form';

import Button from '../../../../../form/buttons/Button/Button';
import ExecutionTimesSingleRow from '../ExecutionTimesSingleRow/ExecutionTimesSingleRow';
import FieldLabel from '../FieldLabel/FieldLabel';

const ExecutionTimesSelector = ({enabled}) => {
  const [openIndex, setOpenIndex] = useState(null);

  const {control} = useFormContext();
  const {fields, append, remove} = useFieldArray({
    control,
    name: 'executionTimes'
  });

  return (
    <>
      <FieldLabel sx={{mt: 2}}>Heures d'exécution</FieldLabel>
      <Alert severity="info" sx={{mb: 1}}>
        Vous pouvez uniquement sélectionner une heure pleine ou une demi-heure (12:00, 12:30 ...)
      </Alert>
      <LocalizationProvider
        dateAdapter={AdapterDayjs}
        localeText={{
          timePickerToolbarTitle: 'Choisir une heure',
          cancelButtonLabel: 'Annuler',
          okButtonLabel: 'Valider'
        }}
      >
        {fields.map((item, index) => (
          <ExecutionTimesSingleRow
            key={item.id}
            index={index}
            enabled={enabled}
            canRemove={fields.length > 1}
            remove={remove}
            open={openIndex === index}
            onOpen={() => setOpenIndex(index)}
            onClose={() => setOpenIndex(null)}
          />
        ))}

        <Button
          variant="outlined"
          startIcon={<AddIcon />}
          onClick={() => {
            const newIndex = fields.length;
            append({time: null});
            setOpenIndex(newIndex);
          }}
          disabled={!enabled}
          size="small"
          sx={{
            mt: 1,
            fontSize: 12
          }}
        >
          Ajouter une heure
        </Button>
      </LocalizationProvider>
    </>
  );
};

ExecutionTimesSelector.propTypes = {
  enabled: PropTypes.bool.isRequired
};

export default ExecutionTimesSelector;
